import { callAPI, HTTPMethod } from './API'
import {
    SignUpMetadataResponse,
    Tenants,
    Tenant,
    TenantListParams,
    TenantRequest,
} from '../model'

export async function getTenants(params: TenantListParams): Promise<Tenants> {
    return await callAPI('/tenants', {
        method: HTTPMethod.GET,
        query: {
            search: params.search ?? '',
            pageSize: `${params.pageSize ?? 20}`,
            offset: `${params.offset ?? 0}`,
        },
    })
}

export async function createTenant(request: TenantRequest): Promise<Tenant> {
    return await callAPI('/tenants', {
        method: HTTPMethod.POST,
        body: request,
    })
}

export async function getMetadata(): Promise<SignUpMetadataResponse> {
    return await callAPI('/tenants/metadata', {
        method: HTTPMethod.GET,
    })
}

export async function getTenant(tenantId: string): Promise<Tenant> {
    return await callAPI(`/tenants/${tenantId}`, {
        method: HTTPMethod.GET,
    })
}

export async function updateTenant(
    tenantId: string,
    request: TenantRequest
): Promise<Tenant> {
    return await callAPI(`/tenants/${tenantId}`, {
        method: HTTPMethod.PUT,
        body: request,
    })
}
